module.exports = __webpack_public_path__ + "static/img/zh_HANT1.1f1c49a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zh_HANT1.png
// module id = qVzH
// module chunks = 1